import { render, staticRenderFns } from "./BlipArtistBlackKeyword.vue?vue&type=template&id=e2b97a2e&scoped=true&"
import script from "./BlipArtistBlackKeyword.vue?vue&type=script&lang=js&"
export * from "./BlipArtistBlackKeyword.vue?vue&type=script&lang=js&"
import style0 from "./BlipArtistBlackKeyword.vue?vue&type=style&index=0&id=e2b97a2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b97a2e",
  null
  
)

export default component.exports